import { type BoxProps, Box, Typography } from "@mui/material";
import React from "react";

type Props = {
  isSelected: boolean;
  Icon: React.ElementType;
  label: string;
  disabled?: boolean;
} & BoxProps;

export const CategoryCard = ({ isSelected, Icon, label, disabled, ...props }: Props) => (
  <Box
    sx={{
      backgroundColor: isSelected ? "primary.main" : "tickets.boxBackground",
      color: isSelected ? "common.white" : "tickets.categoryText",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      cursor: disabled ? "unset" : "pointer",
      borderColor: "tickets.border",
      borderStyle: "solid",
      borderRadius: 1,
      borderWidth: 0.5,
      p: 2,
      height: "100%",
      minHeight: 100,
      textDecoration: isSelected ? "underline 2px" : undefined,
      textUnderlineOffset: isSelected ? "4px" : undefined,
    }}
    aria-current={isSelected}
    {...props}
  >
    <Icon />
    <Typography sx={{ ml: 2, fontWeight: "bold" }}>{label}</Typography>
  </Box>
);
